/* ============================================================================
   Inner Child · Pastel Sequin Cursor
   Upload this file to Shopify:  Edit code → Assets → Add a new asset → Upload
   Then add ONE line before </body> in layout/theme.liquid:
     <script src="{{ 'sequin-cursor.js' | asset_url }}" defer></script>
   Self-contained: no libraries, injects its own styles.
   ============================================================================ */
(function () {
  if (window.__sqnCursor) return;
  window.__sqnCursor = true;

  // ---- options you can tweak --------------------------------------------------
  var HIDE_SYSTEM_CURSOR = true;   // false = keep the normal arrow AND spill sequins
  var MAX_SEQUINS        = 120;    // particle cap (lower = lighter)
  var LEAK_EVERY_PX      = 40;     // smaller = more sequins as you move

  // respect users who ask for less motion / very old browsers
  try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  if (!document.createElement('canvas').getContext) return;

  // inject styles
  var st = document.createElement('style');
  st.textContent =
    'html.sqn-on, html.sqn-on * { cursor: none !important; }' +
    '#sqn-canvas  { position:fixed; inset:0; width:100vw; height:100vh; pointer-events:none; z-index:2147483000; }' +
    '#sqn-pointer { position:fixed; top:0; left:0; pointer-events:none; z-index:2147483001; will-change:transform; opacity:0; transition:opacity .14s; }' +
    '@media (prefers-reduced-motion: reduce) { #sqn-canvas, #sqn-pointer { display:none !important; } }';
  document.head.appendChild(st);

  var PASTEL = [
    { body:'#b9ccbf', light:'#e8f0ea', dark:'#7e9888' },  // sage
    { body:'#8fd2c4', light:'#d8f2eb', dark:'#4f9f90' },  // mint
    { body:'#f2cfa3', light:'#fbe8d2', dark:'#c79a6a' },  // peach
    { body:'#6aacd2', light:'#c6e2f1', dark:'#3a7aa0' },  // blue
    { body:'#b39ad8', light:'#e9def5', dark:'#8268b0' },  // lilac
    { body:'#eef0f2', light:'#ffffff', dark:'#c2c6cc' }   // pearl white
  ];

  var POINTER_SVG =
    '<svg width="15" height="15" viewBox="-15 -15 30 30" style="overflow:visible;display:block;filter:drop-shadow(0 1.5px 2px rgba(42,36,36,.32));">' +
      '<defs>' +
        '<linearGradient id="sqnBody" x1="-9" y1="-9" x2="9" y2="9" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0%" stop-color="#e9f3ff"/><stop offset="26%" stop-color="#f7d6ec"/>' +
          '<stop offset="52%" stop-color="#ecbbe2"/><stop offset="74%" stop-color="#f5ecb6"/>' +
          '<stop offset="100%" stop-color="#cfe6f5"/>' +
        '</linearGradient>' +
        '<radialGradient id="sqnCup" cx="50%" cy="48%" r="58%"><stop offset="0%" stop-color="#f8cde8"/><stop offset="100%" stop-color="#e6b1de"/></radialGradient>' +
        '<radialGradient id="sqnGl" cx="34%" cy="26%" r="48%"><stop offset="0%" stop-color="#ffffff" stop-opacity="0.92"/><stop offset="100%" stop-color="#ffffff" stop-opacity="0"/></radialGradient>' +
      '</defs>' +
      '<circle cx="0" cy="0" r="11" fill="#eee3f4" stroke="rgba(150,120,165,.45)" stroke-width="0.9"/>' +
      '<polygon points="8.6,0 4.3,7.45 -4.3,7.45 -8.6,0 -4.3,-7.45 4.3,-7.45" fill="url(#sqnCup)" stroke="rgba(150,120,170,.5)" stroke-width="0.8" stroke-linejoin="round"/>' +
      '<polygon points="8.6,0 4.3,7.45 -4.3,7.45 -8.6,0 -4.3,-7.45 4.3,-7.45" fill="url(#sqnBody)" opacity="0.5"/>' +
      '<g stroke="rgba(165,135,180,.42)" stroke-width="0.6">' +
        '<line x1="0" y1="0" x2="8.6" y2="0"/><line x1="0" y1="0" x2="4.3" y2="7.45"/><line x1="0" y1="0" x2="-4.3" y2="7.45"/>' +
        '<line x1="0" y1="0" x2="-8.6" y2="0"/><line x1="0" y1="0" x2="-4.3" y2="-7.45"/><line x1="0" y1="0" x2="4.3" y2="-7.45"/>' +
      '</g>' +
      '<path d="M4.3,7.45 L8.6,0" stroke="#fdf3bb" stroke-width="1" stroke-linecap="round" opacity="0.8"/>' +
      '<path d="M-8.6,0 L-4.3,-7.45" stroke="#d8f1ff" stroke-width="0.9" stroke-linecap="round" opacity="0.65"/>' +
      '<ellipse cx="-3.4" cy="-4" rx="5.6" ry="4.4" fill="url(#sqnGl)"/>' +
      '<circle cx="0" cy="0" r="2.2" fill="#ffffff" stroke="rgba(150,120,165,.35)" stroke-width="0.5"/>' +
    '</svg>';

  var canvas, ctx, pointer, w = 0, h = 0, dpr = 1;
  var parts = [], last = null, dist = 0, raf = 0;

  function start() {
    canvas = document.createElement('canvas'); canvas.id = 'sqn-canvas';
    pointer = document.createElement('div'); pointer.id = 'sqn-pointer'; pointer.innerHTML = POINTER_SVG;
    document.body.appendChild(canvas);
    document.body.appendChild(pointer);
    ctx = canvas.getContext('2d');
    if (HIDE_SYSTEM_CURSOR) document.documentElement.classList.add('sqn-on');
    resize();
    window.addEventListener('resize', resize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', resize);
      window.visualViewport.addEventListener('scroll', resize);
    }
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointerup', onUp, { passive: true });
    window.addEventListener('pointercancel', onUp, { passive: true });
    document.addEventListener('pointerleave', hide);
    window.addEventListener('blur', hide);
    raf = requestAnimationFrame(loop);
  }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var vv = window.visualViewport;
    w = vv ? vv.width : window.innerWidth;
    h = vv ? vv.height : window.innerHeight;
    canvas.style.width = w + 'px';        // match CSS size to the *visible* viewport,
    canvas.style.height = h + 'px';       // so a tap maps 1:1 to where sequins spawn
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function show(x, y) {
    pointer.style.opacity = '1';
    pointer.style.transform = 'translate(' + (x - 7.5) + 'px,' + (y - 7.5) + 'px)';
  }
  function hide() { pointer.style.opacity = '0'; last = null; }

  function onMove(e) {
    var x = e.clientX, y = e.clientY;
    if (e.pointerType !== 'touch') show(x, y);   // persistent pointer is for a hovering mouse only
    var lx = last ? last.x : x, ly = last ? last.y : y;
    dist += Math.hypot(x - lx, y - ly);
    while (dist >= LEAK_EVERY_PX) { dist -= LEAK_EVERY_PX; leak(x, y); }
    last = { x: x, y: y };
  }
  function onDown(e) {
    var x = e.clientX, y = e.clientY;
    if (e.pointerType !== 'touch') show(x, y);
    last = { x: x, y: y };
    for (var i = 0; i < 6; i++) leak(x, y);   // tap burst (mobile + click)
  }
  function onUp(e) {
    if (e.pointerType === 'touch') hide();      // no hover on touch — don't leave a stuck sequin
  }

  function leak(px, py) {
    var spec, irid = Math.random() < 0.24;
    if (irid) {
      spec = { irid:true, hue:Math.random()*360, edge:'74,48,88', hi:'255,255,255', metal:0.85, rim:'#eef2ff', hole:'255,255,255', g1:'#fdf3bb', g2:'#d8f1ff' };
    } else {
      var c = PASTEL[(Math.random() * PASTEL.length) | 0];
      spec = { irid:false, color:c.body, light:c.light, dark:c.dark, edge:'58,54,74', hi:'255,255,255', metal:0.42, rim:c.light, hole:'255,255,255', g1:'#fdf3bb', g2:'#d8f1ff' };
    }
    var p = {
      x: px + (Math.random() - 0.5) * 4, y: py + (Math.random() - 0.5) * 4,
      vx: (Math.random() - 0.5) * 0.7, vy: 0.15 + Math.random() * 0.4,
      rot: Math.random() * 6.283, vrot: (Math.random() - 0.5) * 0.18,
      phase: Math.random() * 6.283, vphase: 0.05 + Math.random() * 0.09,
      size: 4.2 + Math.random() * 3.2, t: performance.now()
    };
    for (var k in spec) p[k] = spec[k];
    parts.push(p);
    if (parts.length > MAX_SEQUINS) parts.shift();
  }

  function loop(now) {
    ctx.clearRect(0, 0, w, h);
    var life = 1700, DEG = 1.0471976;
    parts = parts.filter(function (s) { return now - s.t < life; });
    for (var n = 0; n < parts.length; n++) {
      var s = parts[n];
      s.vy += 0.035; s.vx *= 0.99;
      s.x += s.vx; s.y += s.vy; s.rot += s.vrot; s.phase += s.vphase;
      if (s.y > h - 2) { s.y = h - 2; s.vy *= -0.3; s.vx *= 0.6; s.vrot *= 0.7; }
      var age = now - s.t;
      var a = age < life * 0.7 ? 1 : Math.max(0, 1 - (age - life * 0.7) / (life * 0.3));
      var flip = Math.abs(Math.cos(s.phase));
      var r = s.size, fore = 0.16 + flip * 0.84, ry = r * fore, hr = r * 0.8;
      var edge = s.edge, hi = s.hi, metal = s.metal, k;
      ctx.save();
      ctx.translate(s.x, s.y);
      ctx.globalAlpha = a * 0.13; ctx.fillStyle = '#2a2424';
      ctx.beginPath(); ctx.ellipse(0.7, 1.4, r * 0.95, ry * 0.95, s.rot, 0, 6.283); ctx.fill();
      ctx.rotate(s.rot); ctx.scale(1, fore);
      ctx.globalAlpha = a; ctx.fillStyle = s.rim;
      ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.283); ctx.fill();
      var bg = ctx.createRadialGradient(-hr * 0.25, -hr * 0.3, hr * 0.1, 0, 0, hr);
      if (s.irid) {
        var h0 = s.hue + s.phase * 46;
        bg.addColorStop(0, 'hsl(' + ((h0 + 50) % 360) + ',100%,93%)');
        bg.addColorStop(0.4, 'hsl(' + ((h0 + 360) % 360) + ',92%,76%)');
        bg.addColorStop(0.72, 'hsl(' + ((h0 - 60 + 720) % 360) + ',88%,68%)');
        bg.addColorStop(1, 'hsl(' + ((h0 - 110 + 720) % 360) + ',80%,56%)');
      } else {
        bg.addColorStop(0, s.light); bg.addColorStop(0.55, s.color); bg.addColorStop(1, s.dark);
      }
      ctx.fillStyle = bg;
      ctx.beginPath();
      for (k = 0; k < 6; k++) { var aa = k * DEG, x = hr * Math.cos(aa), y = hr * Math.sin(aa); if (k) ctx.lineTo(x, y); else ctx.moveTo(x, y); }
      ctx.closePath(); ctx.fill();
      ctx.globalAlpha = a * 0.5; ctx.strokeStyle = 'rgba(' + edge + ',0.5)'; ctx.lineWidth = 0.5;
      ctx.beginPath();
      for (k = 0; k < 6; k++) { var ab = k * DEG, xb = hr * Math.cos(ab), yb = hr * Math.sin(ab); if (k) ctx.lineTo(xb, yb); else ctx.moveTo(xb, yb); }
      ctx.closePath(); ctx.stroke();
      ctx.beginPath();
      for (k = 0; k < 6; k++) { var ac = k * DEG; ctx.moveTo(0, 0); ctx.lineTo(hr * Math.cos(ac), hr * Math.sin(ac)); }
      ctx.stroke();
      ctx.lineCap = 'round';
      ctx.globalAlpha = a * 0.8; ctx.lineWidth = 0.9; ctx.strokeStyle = s.g1;
      ctx.beginPath(); ctx.moveTo(hr, 0); ctx.lineTo(hr * Math.cos(DEG), hr * Math.sin(DEG)); ctx.stroke();
      ctx.globalAlpha = a * 0.6; ctx.strokeStyle = s.g2;
      ctx.beginPath(); ctx.moveTo(hr * Math.cos(3 * DEG), hr * Math.sin(3 * DEG)); ctx.lineTo(hr * Math.cos(4 * DEG), hr * Math.sin(4 * DEG)); ctx.stroke();
      ctx.globalAlpha = a;
      var hg = ctx.createRadialGradient(-r * 0.3, -r * 0.4, 0, -r * 0.16, -r * 0.24, r * 1.15);
      hg.addColorStop(0, 'rgba(' + hi + ',' + (0.2 + (0.45 + 0.3 * metal) * flip) * (0.5 + metal * 0.5) + ')');
      hg.addColorStop(0.5, 'rgba(' + hi + ',' + (0.1 * flip) + ')');
      hg.addColorStop(1, 'rgba(' + hi + ',0)');
      ctx.fillStyle = hg; ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.283); ctx.fill();
      var spec = flip * flip * flip;
      if (spec > 0.04) {
        ctx.globalAlpha = a * spec * (0.45 + metal * 0.55); ctx.fillStyle = 'rgba(' + hi + ',1)';
        ctx.beginPath(); ctx.ellipse(-r * 0.3, -r * 0.34, r * 0.2, r * 0.2, 0, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = a; ctx.fillStyle = 'rgba(' + s.hole + ',1)';
      ctx.beginPath(); ctx.arc(0, 0, r * 0.2, 0, 6.283); ctx.fill();
      ctx.globalAlpha = a * 0.4; ctx.lineWidth = 0.4; ctx.strokeStyle = 'rgba(' + edge + ',0.5)';
      ctx.beginPath(); ctx.arc(0, 0, r * 0.2, 0, 6.283); ctx.stroke();
      ctx.globalAlpha = a * 0.5; ctx.lineWidth = 0.6; ctx.strokeStyle = 'rgba(' + edge + ',0.4)';
      ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.283); ctx.stroke();
      ctx.restore();
    }
    raf = requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();